/**
 * Decides whether PlanReview's navigation state (location.state, built from
 * the generation response) is usable, or malformed and must fail safely
 * instead of rendering a fabricated target/goal.
 *
 * draftData.daily_target/goal only ever come from a draft-review
 * /smart-fill/auto call, which (per the backend's fail-closed
 * _require_plan_ready_profile gate) only ever succeeds for a profile with
 * real, complete targets and an explicit goal. A navigation state missing
 * either means something upstream went wrong (a stale draft, or this route
 * opened directly) — never render a fabricated 2000/150/200/67 target or an
 * assumed "Maintain" goal as if it were the user's own (see AGENTS.md
 * pre-launch audit nutrition-readiness follow-up).
 */
export function isPlanReviewNavStateUsable(draftData) {
  return !!(draftData && draftData.daily_target && draftData.goal);
}
